<template>
  <label
    class="BSCRadio"
    :class="[{ 'is-disabled': disabled }]"
    ref="label"
    @keydown.prevent.enter="$refs.label.click()"
  >
    <div>
      <slot />
    </div>
    <div class="BSCRadio--wrapper">
      <input
        class="BSCRadio-input"
        type="radio"
        name="radio"
        ref="input"
        v-model="computedValue"
        :value="nativeValue"
        :required="required"
        :disabled="disabled"
      />
      <span class="BSCRadio-checkmark" :class="[`is-${type}`]"></span>
    </div>
  </label>
</template>

<script>
'use strict'

export default {
  name: 'BSCRadio',
  props: {
    value: [String, Number, Boolean, Function, Object, Array],
    nativeValue: [String, Number, Boolean, Function, Object, Array],
    type: {
      type: String,
      default: ''
    },
    disabled: Boolean,
    required: Boolean
  },
  data() {
    return {
      newValue: this.value
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.newValue
      },
      set(value) {
        this.newValue = value
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value(value) {
      this.newValue = value
    }
  }
}
</script>
